var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.082,
    strokeMiterlimit: 2.6131,
    points: "29.691,25.272 29.691,23.862  24.03,23.862 24.03,29.143 29.72,29.143 29.72,27.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1111,
    strokeMiterlimit: 2.6131,
    points: "50.904,29.143 56.15,29.143  56.525,28.747 56.525,24.195 56.15,23.831 50.678,23.831 50.336,24.132 50.336,28.716  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2157,
    strokeMiterlimit: 2.6131,
    points: "15.67,29.507 18.558,23.883  19.129,23.887 22.03,29.507  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2157,
    strokeMiterlimit: 2.6131,
    x1: 16.716,
    y1: 27.481,
    x2: 20.963,
    y2: 27.481
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2346,
    strokeMiterlimit: 2.6131,
    x1: 36.031,
    y1: 23.659,
    x2: 32.146,
    y2: 26.874
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2346,
    strokeMiterlimit: 2.6131,
    x1: 32.146,
    y1: 26.128,
    x2: 36.031,
    y2: 29.314
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2346,
    strokeMiterlimit: 2.6131,
    x1: 32.146,
    y1: 23.274,
    x2: 32.146,
    y2: 29.706
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "12.42,26.519 13.661,25.356  13.661,23.83 7.474,23.83 7.474,26.519 11.557,26.519  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "12.42,26.431 13.661,27.594  13.661,29.12 7.474,29.12 7.474,26.431 11.557,26.431  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 45.492,
    y1: 23.902,
    x2: 45.492,
    y2: 29.724
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 48.66,
    y1: 23.902,
    x2: 42.311,
    y2: 23.902
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 1.1285,
    strokeMiterlimit: 2.6131,
    points: "37.508,40.726 37.508,34.77  43.697,34.77 43.697,37.748 37.508,37.748  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 23.482,
    y1: 34.852,
    x2: 23.482,
    y2: 40.673
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2501,
    strokeMiterlimit: 2.6131,
    x1: 26.65,
    y1: 34.852,
    x2: 20.301,
    y2: 34.852
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 1.2309,
    strokeMiterlimit: 2.6131,
    points: "29.319,40.044 34.535,40.044  34.904,39.651 34.904,35.128 34.535,34.764 29.094,34.764 28.755,35.065 28.755,39.619  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/backToTop.14de7899ca813d025799c74e9670bc8c.svg";
export { ForwardRef as ReactComponent };